export const aboutData = {
  brand: {
    title: '品牌介绍',
    description: '麻豆传媒成立于2018年，是一家专注于移动互联网内容服务的创新型科技企业。公司总部位于中国深圳，在北京、上海、杭州设有研发中心和运营团队，现有员工超过500人。',
    mission: '我们的使命是通过技术创新，为用户提供安全、便捷、丰富的内容消费体验。我们致力于打造中国领先的移动内容平台，让每一位用户都能轻松发现和享受优质内容。',
    vision: '成为全球领先的智能内容分发平台，连接创作者与用户，构建健康、多元的内容生态。',
    milestones: [
      { year: '2018', event: '公司成立，推出麻豆传媒app 1.0版本' },
      { year: '2019', event: '用户突破100万，完成首轮融资' },
      { year: '2020', event: 'AI推荐引擎上线，用户突破500万' },
      { year: '2021', event: '完成B轮融资，团队扩展至300人' },
      { year: '2022', event: '推出直播和社区功能，用户突破2000万' },
      { year: '2023', event: '获得"年度最佳移动应用"奖项' },
      { year: '2024', event: '全球化战略启动，发布国际版本' },
      { year: '2025', event: 'AI智能助手上线，用户突破5000万' },
      { year: '2026', event: 'V3.2.0发布，全面升级用户体验' },
    ],
  },
  reputation: {
    title: '用户口碑',
    subtitle: '来自真实用户的高度评价',
    reviews: [
      {
        name: '王先生',
        role: '资深用户 / 使用2年',
        rating: 5,
        content: '麻豆传媒app是我用过最好的内容平台，界面简洁，推荐精准，每天都在用。离线下载功能特别实用，出差路上也能看。',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20business%20casual%20style%2C%20friendly%20expression&width=200&height=200&seq=avatar-1&orientation=squarish',
      },
      {
        name: '李女士',
        role: 'VIP会员 / 使用1年',
        rating: 5,
        content: '从朋友推荐开始用，现在已经成为生活中不可或缺的一部分。会员体验非常好，无广告特别爽，推荐的内容也很合我口味。',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20modern%20style%2C%20confident%20expression&width=200&height=200&seq=avatar-2&orientation=squarish',
      },
      {
        name: '张同学',
        role: '大学生 / 使用6个月',
        rating: 4,
        content: '作为学生党，免费版就已经够用了。内容很丰富，分类也很清晰，学习累了看看放松一下。希望以后能有更多学生优惠活动。',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%2C%20clean%20minimalist%20background%2C%20warm%20natural%20light%2C%20casual%20style%2C%20friendly%20smile&width=200&height=200&seq=avatar-3&orientation=squarish',
      },
      {
        name: '刘先生',
        role: '上班族 / 使用3年',
        rating: 5,
        content: '从V1.0版本就开始用了，见证了麻豆的每一步成长。现在的版本功能越来越完善，体验也越来越好。客服响应也很快，值得信赖。',
        avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20professional%20male%20portrait%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20formal%20style%2C%20confident%20expression&width=200&height=200&seq=avatar-4&orientation=squarish',
      },
    ],
    stats: [
      { label: '累计用户', value: '5000万+' },
      { label: '日活跃用户', value: '800万+' },
      { label: '应用评分', value: '4.8/5' },
      { label: '内容数量', value: '100万+' },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '如有任何问题或建议，欢迎通过以下方式联系我们',
    email: 'support@madouapp.com',
    phone: '400-888-9999',
    address: '广东省深圳市南山区科技园南路88号麻豆传媒大厦',
    workingHours: '周一至周五 9:00-18:00（法定节假日除外）',
    socialLinks: [
      { name: '微信公众号', icon: 'ri-wechat-line', url: '#' },
      { name: '官方微博', icon: 'ri-weibo-line', url: '#' },
      { name: '官方抖音', icon: 'ri-tiktok-line', url: '#' },
      { name: '官方B站', icon: 'ri-bilibili-line', url: '#' },
    ],
  },
};